import * as watchlistSnapshotActions from '../../actions/watchlist-snapshots.actions';
import { WatchlistSnapshot } from '../../model/watchlist-snapshot';


/**
 * items reducer, contains watchlist snapshot items
 *
 * @param state the current state
 * @param action an action that may result in returning a new state
 * @returns the new state
 */
export const items = (state: {[uuid: string]: WatchlistSnapshot} = {},
                      action: watchlistSnapshotActions.Actions): {[uuid: string]: WatchlistSnapshot} => {
  switch (action.type) {
    case watchlistSnapshotActions.FETCH_ITEM_SUCCEEDED:
      const newWatchlist = action.payload.snapshot;

      const stateWithNewDetails = { ...state };

      stateWithNewDetails[newWatchlist.uuid] = {
        ...newWatchlist,
        detailsLoaded: true
      };

      if (Array.isArray(action.payload.subSnapshots)) {
        action.payload.subSnapshots.forEach(snapshot => {
          stateWithNewDetails[snapshot.uuid] = {
            ...snapshot,
            detailsLoaded: false,
            parentUuid: action.payload.snapshot.uuid
          };
        });
      }

      return stateWithNewDetails;
    default:
      return state;
  }
};
